import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const studioLinks = [
  { label: "Web Design & Build", to: "/services" },
  { label: "AI Automation", to: "/services" },
  { label: "Performance Ads", to: "/services" },
  { label: "SEO & Growth", to: "/services" },
  { label: "Brand Story", to: "/services" },
];

const aboutLinks = [
  { label: "Our Story", to: "/about" },
  { label: "How We Work", to: "/about" },
  { label: "Selected Work", to: "/work" },
  { label: "Get in Touch", to: "/contact" },
];

const supportLinks = [
  { label: "Contact", to: "/contact" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Refund Policy", to: "/refund-policy" },
];

export default function Footer() {
  return (
    <footer className="lq-footer-shell">
      <motion.div
        className="liquid-glass lq-footer"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 1, delay: 0.1, ease: "easeOut" }}
      >
        <div className="lq-grid">
          {/* Brand column */}
          <div className="lq-brand-col">
            <div className="lq-brand">
              <FooterLogo />
              <span className="lq-brand-name">Sutranode</span>
            </div>
            <p className="lq-brand-desc">
              A growth studio for thoughtful brands. We craft websites, run ads,
              automate with AI, and grow businesses that have something real
              to offer.
            </p>
            <div className="lq-availability">
              <span className="lq-pulse" />
              <span>Currently taking on a few thoughtful partnerships</span>
            </div>
          </div>

          {/* Link columns */}
          <div className="lq-links">
            <div className="lq-link-col">
              <h4>Studio</h4>
              <ul>
                {studioLinks.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lq-link-col">
              <h4>The Studio</h4>
              <ul>
                {aboutLinks.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lq-link-col">
              <h4>Support</h4>
              <ul>
                {supportLinks.map((l, i) => (
                  <li key={i}>
                    <Link to={l.to}>{l.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="lq-bottom">
          <p className="lq-copy">
            © 2026 Sutranode
          </p>
          <div className="lq-social-row">
            <span className="lq-social-label">Find us</span>
            <div className="lq-socials">
              <a
                href="https://www.instagram.com/sutranode/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <IconInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/sutranode/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <IconLinkedIn />
              </a>
              <a
                href="https://twitter.com/sutranode"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X / Twitter"
              >
                <IconX />
              </a>
              <a
                href="https://www.youtube.com/@sutranode"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <IconYouTube />
              </a>
              <a
                href="https://wa.me/917020000000"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <IconWhatsApp />
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    </footer>
  );
}

function FooterLogo() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="ftlg" x1="0" y1="0" x2="28" y2="28">
          <stop offset="0" stopColor="#00e5ff" />
          <stop offset=".5" stopColor="#a78bfa" />
          <stop offset="1" stopColor="#ff5ec4" />
        </linearGradient>
      </defs>
      <circle cx="14" cy="14" r="12" stroke="url(#ftlg)" strokeWidth="1.4" opacity="0.55" />
      <path d="M5 5 L23 23 M23 5 L5 23" stroke="url(#ftlg)" strokeWidth="2" strokeLinecap="round" />
      <circle cx="14" cy="14" r="2.4" fill="url(#ftlg)" />
    </svg>
  );
}

/* ---------- Inline social icons (no extra deps) ---------- */
function IconInstagram() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect width="20" height="20" x="2" y="2" rx="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
    </svg>
  );
}

function IconLinkedIn() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z" />
      <rect width="4" height="12" x="2" y="9" />
      <circle cx="4" cy="4" r="2" />
    </svg>
  );
}

function IconX() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

function IconYouTube() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17" />
      <path d="m10 15 5-3-5-3z" />
    </svg>
  );
}

function IconWhatsApp() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.83 9.83 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.82 11.82 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.88 11.88 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.82 11.82 0 0 0 20.464 3.488" />
    </svg>
  );
}
